function LoginSettings($scope, $state, $timeout, GeneralUtilsService){
    $scope.loadAccount = function(){
        store.fetch({
            path: "getAccountSettings",
            queryParams: {'accountId': $state.params.accountId,'type':'account'},
            success: function(data) {
                $timeout(function(){
                    $scope.account = data;
                    $scope.orig = angular.copy($scope.account);
                    initLoginIps();
                    $('[data-toggle="tooltip"]').tooltip();
                }, 0);
            }
        });
    };

    $scope.loadAccount();

    $scope.$root.hasChanges = function(){
        if(!$scope.account) return false;
        const allowSSOLogin = $scope.account.accountAuthSettings.allowSSOLogin !== $scope.orig.accountAuthSettings.allowSSOLogin;
        const catoCredsLoginAllowed = $scope.account.accountAuthSettings.allowCatoCredsLogin !== $scope.orig.accountAuthSettings.allowCatoCredsLogin;
        const loginIpChanged1 = $scope.account.loginIpsEnabled !== $scope.orig.loginIpsEnabled;
        const loginIpChanged2 = $scope.account.loginEgressIpsEnabled !== $scope.orig.loginEgressIpsEnabled;
        const loginIpsChanged = !angular.equals($scope.loginIpsConfig.items, $scope.loginIpsOrig);
        const passwordExpirationPolicyChanged = !angular.equals($scope.account.passwordExpirationPolicy, $scope.orig.passwordExpirationPolicy);
        return (allowSSOLogin || catoCredsLoginAllowed ||loginIpChanged1 || loginIpChanged2 || loginIpsChanged || passwordExpirationPolicyChanged);
    };


    $scope.loginIpsConfig = {
        titleSearch: true,
        dataURL : function(){
            return null;
        },
        parseData : function() {
            // the account is usually not defined yet here
            var existingIps = [];
            if ($scope.account) {
                $scope.account.loginIps.forEach(function(item) {
                    existingIps.push({id:GeneralUtilsService.getRandomId(),"ip":item})
                });
                $scope.loginIpsOrig = angular.copy(existingIps);
            }
            return existingIps;
        },
        fields : [
            {"label":"Specific Login IPs","template":"<span><input type='text' class='form-control' ng-model='item.ip' /></span>",path:"ip"}
        ],
        actions : [],
        addAction : function(){
            $scope.loginIpsConfig.items.push({id:GeneralUtilsService.getRandomId(),"ip":""});
        },
        clientSideSearch: true,
        specialActions : [
            {"func":function(selectedItems) {
                selectedItems.forEach(function(item) {
                    for(var i = 0 ; i < $scope.loginIpsConfig.items.length ; i++){
                        var subnet = $scope.loginIpsConfig.items[i];
                        if(subnet.id === item.id){
                            $scope.loginIpsConfig.items.splice(i,1);
                            break;
                        }
                    }
                });
            },"icon":"delete",tooltip:"Delete"}
        ],
        selectedItems:[],
        pageSize:10,
        noSearch:true
    };

    var initLoginIps = function() {
        $timeout(function(){
            if(!$scope.loginIpsConfig.items){
                $scope.loginIpsConfig.items = [];
            }

            $scope.loginIpsConfig.items.length = 0; // clear from previous data (in case of init after save request)
            $scope.loginIpsOrig = [];
            if($scope.account.loginIps) {
                $scope.account.loginIps.forEach(function(item) {
                    var newItem = {
                        id: GeneralUtilsService.getRandomId(),
                        ip: item
                    };

                    $scope.loginIpsConfig.items.push(newItem);
                });
            }

            $scope.loginIpsOrig = angular.copy($scope.loginIpsConfig.items);
        }, 1, false);
    };

    var updateLoginIps = function(){
        $scope.account.loginIps = [];
        $scope.loginIpsConfig.items.forEach(function(item) {
            $scope.account.loginIps.push(item.ip);
        });
        if ($scope.account.loginIpsEnabled && $scope.account.loginIps.length == 0) {
            $scope.$root.alert('It is recommended to add at least one "non-Cato" IP');
        }
    };

    $scope.validate = function() {
        if (!Number.isInteger($scope.account.passwordExpirationPolicy.expirationTimeDuration)) {
            $scope.$root.showNotification('error', 'Please provide a positive whole number', 'Error', true, false);
            return false;
        }
        return true;
    }

    $scope.saveChanges = function() {
        // admin login IP
        updateLoginIps();
        $scope.loading = true;

        if (!$scope.validate()) {
            $scope.loading = false;
            return;
        }

        // send save request
        $scope.account.newSaveMethod = true;
        setData($state.params.accountId, $scope.miniAccount(), function (data) {
            $timeout(function () {
                $scope.loading = false;
            }, 0);
            $scope.$root.handleServerResponse(data, "", "Account settings saved successfully");
            if (data.status !== "ERROR") {
                $scope.loadAccount();
            }
        });
    }

    $scope.miniAccount = function() {
        let account = {};
        account.id = $state.params.accountId;
        account.newSaveMethod = true;
        account.accountAuthSettings = $scope.account.accountAuthSettings;
        if(!account.accountAuthSettings){
            account.accountAuthSettings = {};
        }
        account.accountAuthSettings.newSaveMethod = true;
        account.accountAuthSettings.name = "AccountAuthSettings";
        account.accountAuthSettings.allowSSOLogin = $scope.account.accountAuthSettings.allowSSOLogin;
        account.accountAuthSettings.allowCatoCredsLogin = $scope.account.accountAuthSettings.allowCatoCredsLogin;
        account.accountAuthSettings.id = $state.params.accountId;
        account.accountAuthSettings.account = $state.params.accountId;
        account.loginIpsEnabled = $scope.account.loginIpsEnabled;
        account.loginEgressIpsEnabled = $scope.account.loginEgressIpsEnabled;
        if(!account.loginIps){
            account.loginIps = [];
        }
        account.loginIps = $scope.account.loginIps;
        account.passwordExpirationPolicy = $scope.account.passwordExpirationPolicy;
        return account;
    }

    var setData = function(accountId, account, callback) {
        store.save({
            path: '/edit',
            data: account,
            dataObj: 'json',
            queryParams: {
                accountId: accountId,
                save: true,
                fields: "['accountAuthSettings','loginIpsEnabled','loginEgressIpsEnabled','loginIps', 'passwordExpirationPolicy']",
            },
            success: function (data) {
                callback(data);
            },
        });
    }

}